module.exports = __webpack_public_path__ + "static/media/hp_19.6b1b76d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/JPEG/hp_19.jpg
// module id = 5830
// module chunks = 0